<template>
  <v-menu :close-on-content-click="false" offset-y>
    <template v-slot:activator="{ on, attrs }">
      <v-chip :class="mdAndDown ? 'state-md-and-down' : 'state'" :color="zueri9StateBgColor" dark small v-bind="attrs" v-on="on">
        {{ zueri9State }}
      </v-chip>
    </template>
    <v-list>
      <v-list-item-group v-model="selectedZueri9State" mandatory>
        <v-list-item v-for="(state, index) in zueri9States" :key="index" :value="state.id" :disabled="disabledSystemValues.includes(state.systemValue)">
          <v-chip :disabled="disabledSystemValues.includes(state.systemValue)" width="100%" :style="`background:${state.bgColor};color:white`">
            <v-avatar v-if="absence['zueri9State'] === state.id" left>
              <v-icon color="white">mdi-checkbox-marked-circle</v-icon>
            </v-avatar>
            {{ state.text }}
          </v-chip>
        </v-list-item>
      </v-list-item-group>
    </v-list>
  </v-menu>
</template>

<script>
import { mapState } from 'vuex';
import common from '@/mixins/common';
import wsMixin from '@/modules/customerVbzWorksheet/wsMixin';

export default {
  name: 'Zueri9State',
  mixins: [common, wsMixin],
  props: {
    column: Object,
    absence: Object,
    isAssignedToDifferentView: Boolean,
  },
  data() {
    return {
      disabledSystemValues: ['forwarded', 'returnedAndOpen', 'returnedToAuthor'],
      selectedZueri9State: this.absence['zueri9State'],
    };
  },
  computed: {
    ...mapState('vbzWorksheet', ['zueri9States']),
    zueri9State() {
      return this.mx_zueri9State(this.absence);
    },
    zueri9StateBgColor() {
      return this.mx_zueri9StateBgColor(this.absence);
    },
  },
  watch: {
    selectedZueri9State(newValue, oldValue) {
      this.absence['zueri9State'] = newValue;
      this.$emit('inlineChange', { absence: this.absence, property: 'zueri9State' });
    },
  },
};
</script>

<style scoped>
.state,
.state-md-and-down {
  padding: 4px 8px;
  border-radius: 16px;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: wrap;
  text-align: center;
  font-size: 0.7em !important;
}
.state {
  white-space: pre;
}
.state-md-and-down {
  white-space: break-spaces !important;
}
</style>
